import React from 'react';
import PropTypes from 'prop-types';

const PromoNumberLabel = ({ phoneNumber }) => (
  <div className="sb-field-group" id="promo_number_field">
    <label data-label="promo-number-label" className="sb-field-label">Promo Number</label>
    <div id="promo_number_fixed">{phoneNumber}</div>
  </div>
);

PromoNumberLabel.propTypes = {
  phoneNumber: PropTypes.string.isRequired
};

export default PromoNumberLabel;
